/* eslint-disable no-underscore-dangle */
import jwt from 'jsonwebtoken'

export function isProdBuild() {
  const nodeEnv = window._env_ ? jwt.decode(window._env_).NODE_ENV : process.env.NODE_ENV
  return nodeEnv === 'production'
}

export function isProdEnv() {
  const env = window._env_ ? jwt.decode(window._env_).ENV : process.env.ENV
  return ['production', 'prod', 'preprod'].includes(env)
}
